(g=>{var h,a,k,p="The Google Maps JavaScript API",c="google",l="importLibrary",q="__ib__",m=document,b=window;b=b[c]||(b[c]={});var d=b.maps||(b.maps={}),r=new Set,e=new URLSearchParams,u=()=>h||(h=new Promise(async(f,n)=>{await (a=m.createElement("script"));e.set("libraries",[...r]+"");for(k in g)e.set(k.replace(/[A-Z]/g,t=>"_"+t[0].toLowerCase()),g[k]);e.set("callback",c+".maps."+q);a.src=`https://maps.${c}apis.com/maps/api/js?`+e;d[q]=f;a.onerror=()=>h=n(Error(p+" could not load."));a.nonce=m.querySelector("script[nonce]")?.nonce||"";m.head.append(a)}));d[l]?console.warn(p+" only loads once. Ignoring:",g):d[l]=(f,...n)=>r.add(f)&&u().then(()=>d[l](f,...n))})({
  key: "AIzaSyAxruDu9EMwv2YoLaG4UYx0skZpR9NJ9LI",
  v: "weekly",
});
import 'whatwg-fetch'; // For fetch support in older browsers
import { MarkerClusterer } from "@googlemaps/markerclusterer";

class StoreLocator {
  constructor() {
    this.map = null;
    this.infoWindow = null;
    this.markers = [];
    this.stores = [];
    this.searchRadius = 25 * 1000; // 25 km radius
    this.currentLocation = null;
    this.language = this.getLanguageFromUrl();
    this.country = this.getCountryFromUrl();
    this.listButtonText = this.getListButtonText();
    // console.log(this.listButtonText);

    // console.log(this.language);
    // console.log(this.country);
    // Bind methods
    this.initMap = this.initMap.bind(this);
    this.fetchStoreData = this.fetchStoreData.bind(this);
    this.getCurrentLocation = this.getCurrentLocation.bind(this);
    this.handleLocationError = this.handleLocationError.bind(this);
    this.showMarkers = this.showMarkers.bind(this);
    this.clearMarkers = this.clearMarkers.bind(this);
    this.displayStores = this.displayStores.bind(this);
    this.selectStore = this.selectStore.bind(this);
    this.searchStores = this.searchStores.bind(this);
    this.calculateDistance = this.calculateDistance.bind(this);
    this.initAutocomplete = this.initAutocomplete.bind(this);
    this.scrollToActiveItem = this.scrollToActiveItem.bind(this);
    this.scrollToTop = this.scrollToTop.bind(this);
    this.markerCluster = null; // Add this line to store MarkerClusterer instance

    document.addEventListener('DOMContentLoaded', async () => {
      if (typeof google === 'object' && typeof google.maps === 'object') {
        await this.loadLibraries(); // Load the necessary libraries
        this.initMap();
        this.initAutocomplete(); // Initialize autocomplete
      } else {
        document.querySelector('script[src*="maps.googleapis.com"]').addEventListener('load', async () => {
          await this.loadLibraries(); // Load the necessary libraries
          this.initMap();
          this.initAutocomplete(); // Initialize autocomplete
        });
      }

      document.getElementById('locate-btn').addEventListener('click', this.getCurrentLocation);
      document.getElementById('search-btn').addEventListener('click', this.searchStores);
    });
  }
  
  getListButtonText() {
    return this.language === 'fr' ? "Plus d'informations" : 'Meer informatie';
  }
  
  getLanguageFromUrl() {
    return window.location.pathname.includes('/fr/') ? 'fr' : 'nl';
  }

  getCountryFromUrl() {
    const hostname = window.location.hostname;
    if (hostname.endsWith('.be')) {
      return 'BE';
    } else if (hostname.endsWith('.nl')) {
      return 'NL';
    } else {
      return 'NL'; // Default to NL
    }
  }

  async loadLibraries() {
    await google.maps.importLibrary("maps");
    await google.maps.importLibrary("marker");
    await google.maps.importLibrary("places");
  }

  async initMap() {
    try {
      const mapElement = document.getElementById('map');
      if (!mapElement) {
        console.error('Map element not found');
        return;
      }
  
      // Lees data attributen uit
      const lat = parseFloat(mapElement.getAttribute('data-lat'));
      const lng = parseFloat(mapElement.getAttribute('data-lng'));
      const zoom = parseInt(mapElement.getAttribute('data-zoom'));

      const bounds = new google.maps.LatLngBounds(
        new google.maps.LatLng(40, -10), // Southwest point
        new google.maps.LatLng(60, 21)   // Northeast point
      );

      // Initialize the map
      this.map = new google.maps.Map(mapElement, {
        center: { lat: lat || 52.1326, lng: lng || 5.2913 }, // Use data attributes or default to center of the Netherlands
        zoom: zoom || 7, // Use data attribute or default zoom level
        mapId: 'def92cff52d51321', // Voeg hier je Map ID toe
        restriction: {
          latLngBounds: bounds,
          strictBounds: false,
        },
        minZoom: 6, // Set minimum zoom level
        maxZoom: 14 // Set maximum zoom level
      });

      // Initialize info window
      this.infoWindow = new google.maps.InfoWindow();

      // Fetch store data
      this.fetchStoreData();

      console.log("Map initialized successfully");
    } catch (error) {
      console.error("Error initializing the map:", error);
    }
  }

  async fetchStoreData() {
    const currentUrl = window.location.pathname;
    const apiUrl = currentUrl.includes('/fr/') ? '/fr/wp-json/custom/v1/garages/' : '/wp-json/custom/v1/garages/';

    try {
        const response = await fetch(apiUrl);
        const data = await response.json();
        this.stores = data.features;
        this.stores.sort((a, b) => a.properties.naam.localeCompare(b.properties.naam)); // Alphabetically sort the stores
        this.displayStores(this.stores);
        this.showMarkers(this.stores);
    } catch (error) {
        console.error('Error fetching store data:', error);
    }
}


  getCurrentLocation() {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(position => {
        const pos = {
          lat: position.coords.latitude,
          lng: position.coords.longitude
        };
        document.getElementById('locate-btn').classList.add('active');
        this.currentLocation = pos;
        this.map.setCenter(pos);
        this.map.setZoom(12);
        this.searchStores();
      }, () => {
        this.handleLocationError(true, this.infoWindow, this.map.getCenter());
      });
    } else {
      this.handleLocationError(false, this.infoWindow, this.map.getCenter());
    }
  }

  handleLocationError(browserHasGeolocation, infoWindow, pos) {
    infoWindow.setPosition(pos);
    infoWindow.setContent(browserHasGeolocation ?
      'Error: The Geolocation service failed.' :
      'Error: Your browser doesn\'t support geolocation.');
    infoWindow.open(this.map);
  }

  showMarkers(stores) {
    this.clearMarkers();
    stores.forEach(store => {
      const uniqueId = store.properties.id; // Assuming 'id' is a unique identifier for each store
      const markerElement = document.createElement('div');
      markerElement.classList.add('marker');
      markerElement.innerHTML = `<img src="/wp-content/themes/wubbe/assets/icons/location-pin.svg" />`;

      const marker = new google.maps.marker.AdvancedMarkerElement({
        position: {
          lat: store.geometry.coordinates[1],
          lng: store.geometry.coordinates[0]
        },
        map: this.map,
        content: markerElement
      });

      marker.id = `marker-${uniqueId}`;

      marker.addListener('click', () => {
        this.selectStore(store);
        this.scrollToActiveItem();
      });

      this.markers.push(marker);
    });

    this.initializeMarkerClusterer();
  }
  initializeMarkerClusterer() {

    const markers = this.markers;
    const map = this.map;

    const renderer = {
      render: ({ count, position }) => {
        const color = count > 10 ? "#ff0000" : "#0000ff";

        // create svg url with fill color
        const svg = window.btoa(`
          <svg fill="${color}" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 240 240">
            <circle cx="120" cy="120" opacity=".6" r="70" />
            <circle cx="120" cy="120" opacity=".3" r="90" />
            <circle cx="120" cy="120" opacity=".2" r="110" />
            <circle cx="120" cy="120" opacity=".1" r="130" />
          </svg>`);

        // create marker using svg icon
        return new google.maps.Marker({
          position,
          map: this.map,
          icon: {
            // url: `data:image/svg+xml;base64,${svg}`,
            url: '/wp-content/themes/wubbe/assets/icons/marker-cluster-bg.svg',
            scaledSize: new google.maps.Size(45, 45),
          },
          label: {
            text: String(count),
            color: "rgba(255,255,255,0.9)",
            fontSize: "12px",
          },
          // adjust zIndex to be above other markers
          zIndex: (google.maps.Marker.MAX_ZINDEX) + count,
        });
      }
    };

    this.markerCluster = new MarkerClusterer({
      markers,
      map,
      renderer,
      algorithmOptions: { maxZoom: 9 }
     });
  }

  clearMarkers() {
    if (this.markerCluster) {
      this.markerCluster.clearMarkers();
    }
    this.markers.forEach(marker => marker.map = null);
    this.markers = [];
  }

  displayStores(stores) {
    const storeList = document.getElementById('store-list');
    if (!storeList) {
      console.error('Store list element not found');
      return;
    }
    storeList.innerHTML = '';
    stores.forEach(store => {
      const uniqueId = store.properties.id; // Assuming 'id' is a unique identifier for each store
      const li = document.createElement('li');
      const distance = this.currentLocation ? this.calculateDistance(store.geometry.coordinates, this.currentLocation) : null;
      li.id = `store-${uniqueId}`;
      li.innerHTML = `
        <div class="store-details">
          <div class="store-info">
            <strong class="text-sm">${store.properties.naam}</strong>
            <div class="store-info-subtext">${distance ? `<span class="distance">${distance.toFixed(1)} km</span><span class="seperator"> - </span>` : ''}
            ${store.properties.plaats}</div>
          </div>
          <a href="${store.properties.url}" class="view-store button"><span class="link-animate">${this.listButtonText}</span></a>
        </div>
      `;

      if (uniqueId === this.selectedStoreId) {
        li.classList.add('active');
      }
      li.addEventListener('click', () => {
        this.selectStore(store);
      });
      storeList.appendChild(li);
    });
  }


  selectStore(store, pan=true) {
    const uniqueId = store.properties.id; // Assuming 'id' is a unique identifier for each store

    if(pan) {
      this.map.panTo({
        lat: store.geometry.coordinates[1],
        lng: store.geometry.coordinates[0]
      });
      
      this.map.setZoom(10);
    }

    
    // Markeer de geselecteerde store
    this.selectedStoreId = uniqueId;
  
    // Stel de huidige locatie alleen in als deze nog niet is ingesteld
    if (!this.currentLocation) {
      this.setCurrentLocation(store.geometry.coordinates[1], store.geometry.coordinates[0]);
      this.scrollToTop();
    }
    // Update markers
    this.markers.forEach((marker) => {
      if (marker.id === `marker-${uniqueId}`) {
        marker.content.innerHTML = `<img src="/wp-content/themes/wubbe/assets/icons/location-pin-selected.svg" />`; // Path to selected marker icon
        marker.element.classList.add('selected');
      } else {
        marker.content.innerHTML = `<img src="/wp-content/themes/wubbe/assets/icons/location-pin.svg" />`;
        marker.element.classList.remove('selected');
      }
    });

    // Sorteer stores op afstand tot de geselecteerde store
    this.sortAndDisplayStores(this.stores);
  }

  searchStores() {
    if (this.currentLocation) {
      this.sortAndDisplayStores(this.stores);
    } else {
      this.displayStores(this.stores);
    }

    // remove hide-mobile on first search
    const storeList = document.querySelector('.store-list');
    storeList.classList.remove('hide-mobile');
  }

  sortAndDisplayStores(stores) {
    if (this.currentLocation) {
      stores.sort((a, b) => {
        const distanceA = this.calculateDistance(a.geometry.coordinates, this.currentLocation);
        const distanceB = this.calculateDistance(b.geometry.coordinates, this.currentLocation);
        return distanceA - distanceB;
      });
    }
    this.displayStores(stores);
  }

  calculateDistance(coords, currentLocation) {
    const [lng, lat] = coords;
    const R = 6371; // Radius of the Earth in km
    const dLat = (lat - currentLocation.lat) * Math.PI / 180;
    const dLng = (lng - currentLocation.lng) * Math.PI / 180;
    const a = 
      Math.sin(dLat/2) * Math.sin(dLat/2) +
      Math.cos(currentLocation.lat * Math.PI / 180) * Math.cos(lat * Math.PI / 180) *
      Math.sin(dLng/2) * Math.sin(dLng/2);
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1-a));
    return R * c; // Distance in km
  }

  initAutocomplete() {
    const input = document.getElementById('search-input');
    const autocomplete = new google.maps.places.Autocomplete(input, {
      // componentRestrictions: { country: ['NL', 'BE'] } // Limit results to Netherlands, Belgium, and Germany
      componentRestrictions: { country: [this.country] } // Limit results to Netherlands
    });
    autocomplete.setFields(['address_components', 'geometry', 'name']);

    autocomplete.addListener('place_changed', () => {
      const place = autocomplete.getPlace();

      if (!place.geometry) {
        console.error("No details available for input: '" + place.name + "'");
        return;
      }
      this.scrollToTop();
      // If the place has a geometry, then present it on a map.
      if (place.geometry.viewport) {
        this.map.fitBounds(place.geometry.viewport);
        // Check the zoom level after fitting bounds and set to 10 if it's less than 10
        google.maps.event.addListenerOnce(this.map, 'bounds_changed', () => {
          if (this.map.getZoom() > 10) {
            this.map.setZoom(10);
          }
        });
      } else {
        this.map.setCenter(place.geometry.location);
        this.map.setZoom(12);  // Set zoom level to 12
      }

      this.currentLocation = {
        lat: place.geometry.location.lat(),
        lng: place.geometry.location.lng()
      };

      // Perform search based on the selected place
      this.searchStores();

      // After search has been performed, select the first store in the list
      if (this.stores.length > 0) {
        this.selectStore(this.stores[0], false);
      }
    });
  }

  setCurrentLocation(lat, lng) {
    this.currentLocation = {
      lat: lat,
      lng: lng
    };
  }
  
  scrollToTop() { 

    const storeList = document.querySelector('.store-list');
    storeList.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
    // storeList.scrollTop = 0;
    console.log('scrolltop');
  }

  scrollToActiveItem() {
    const storeList = document.querySelector('.store-list');
    const activeItem = storeList.querySelector('li.active');
    if (activeItem) {
      const offset = activeItem.offsetTop - storeList.offsetTop - storeList.clientHeight / 2 + activeItem.clientHeight;
      storeList.scrollTo({
        top: offset,
        behavior: 'smooth'
      });
    }
  }
}

new StoreLocator();
